<div class="container">
  <a routerLink="/joinChallenge">
    <img src="../assets/VERSUS.png">
  </a>
</div>
